import { SERVICE_URL } from '../tripApiService';
import { AcceptedCurrency } from 'src/types/trip';
import { UserRegion } from '../tripApiService/types';
import { DEPARTURES_QUERY } from './departures.queries';
import { TripDeparture } from 'src/types/gql-generated-types';
import { Departure } from './departures.model';
import { parseISO } from 'date-fns';

export async function getAllDeparturesForAllTrips(
  customerCurrency: AcceptedCurrency,
  customerLanguage: UserRegion,
): Promise<{ tripCode: string; departures: Departure[] }[]> {
  const response = await fetch(SERVICE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query: DEPARTURES_QUERY,
      variables: { customerCurrency, customerLanguage },
    }),
  });

  const { data } = await response.json();

  return data.trips.map((trip: { code: string; tripDepartures: TripDeparture[] }) => ({
    tripCode: trip.code,
    departures: trip.tripDepartures.map(deserializeTripDeparture),
  }));
}

export const deserializeTripDeparture = (data: TripDeparture): Departure => ({
  capacity: data.capacity,
  code: data.code,
  departureDate: parseISO(data.departureDate),
  deposit: data.deposit
    ? {
        amount: data.deposit.amount,
        label: data.deposit.label,
      }
    : null,
  discountType: data.discountType,
  earlyBirds: data.earlyBirds,
  finalPrice: {
    amount: data.finalPrice.amount,
    label: data.finalPrice.label,
  },
  id: data.id,
  isBeingFilmed: data.isBeingFilmed,
  isFull: data.isFull,
  isInsider: data.isInsider,
  notes: data.notes ?? null,
  occupancy: data.occupancy,
  originalPrice: {
    amount: data.originalPrice.amount,
    label: data.originalPrice.label,
  },
  packLeader: data.packLeader ?? null,
  promo: data.promo
    ? {
        promoText: data.promo.promoText ?? null,
      }
    : null,
  remainingSpots: data.remainingSpots
    ? {
        count: data.remainingSpots.count,
        label: data.remainingSpots.label,
        warningType: data.remainingSpots.warningType,
      }
    : null,
  returnDate: parseISO(data.returnDate),
  specialLabel: data.specialLabel ?? null,
  specialLabelNotes: data.specialLabelNotes ?? null,
  status: data.status,
});
